import React from "react";
import { connect } from "react-redux";
import Button from "../../components/buttons/Button";

class About extends React.Component {
  render() {
    return (
      <div>
        <dl>
          {!this.props.user.anonymous && (
            <div>
              <dt>{this.props.text("about.user")}</dt>
              <dd>{this.props.user.properties.USERNAME}</dd>

              <dt className="margin-top-1em">{this.props.text("about.sip")}</dt>
              <dd>{this.props.user.properties.SIP_ADDRESS}</dd>
            </div>
          )}
          <dt className="margin-top-1em">{this.props.text("about.version")}</dt>
          <dd>{this.props.config.version}</dd>

          <dt className="margin-top-1em">{this.props.text("about.browser")}</dt>
          <dd>{this.props.config.browser.name}</dd>

          <dt className="margin-top-1em">
            {this.props.text("about.browserversion")}
          </dt>
          <dd>{this.props.config.browser.version}</dd>

          <dt className="margin-top-1em">{this.props.text("about.os")}</dt>
          <dd>{this.props.config.browser.os}</dd>
        </dl>
        {this.props.smallScreenMode && (
          <div className="d-flex justify-content-between">
            <div></div>
            <div className="float-right">
              <Button
                title=" "
                to={"/settings"}
                text={this.props.text("common.cancel")}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    config: state.config,
    user: state.user,
    text: state.config.text,
  };
};

export default connect(mapStateToProps)(About);






// WEBPACK FOOTER //
// ./src/containers/settings/About.js